<template>
  <div class="panel-footer d-flex justify-content-left">
    <router-link 
      :to="routerLinkTo">
      <span @click="handlePanelFooterClick">{{ text }}</span>
    </router-link>
  </div>
</template>

<script>
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "panel-footer",
  mixins: [HomebaseMixpanelMixin],
  props: ["text", "routerLinkTo", "eventName"],
  methods: {
    handlePanelFooterClick() {
      this.trackPanelFooterClick(this.eventName);
    },
  },
};
</script>
<style scoped>
.panel-footer > a {
  font-family: artifaktElementBold;
  text-decoration: underline;
  font-size: 16px;
  line-height: 80px;
  padding-left: 48px;
  max-height: 80px;
  text-align: left !important;
  color: var(--secondary-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/panels/PanelFooter.vue